import React, { Fragment, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Button,
  Label,
  ButtonDropdown,
  Form,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardTitle,
  CardText,
} from "reactstrap";
import BackInStockTable from "../../backInStock/content/backInStockTable";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import PreLoader from "../../../share-components/ui/preLoader";

const statusValue = {
  1: "badge-primary",
  2: "badge-success",
  3: "badge-warning",
};

const MismatchStatus = ({ value }) => {
  const isMismatch = Boolean(value);

  return (
    <span
      style={{
        color: isMismatch ? "#dc0000" : "#139a35",
        fontWeight: 600,
      }}
    >
      {isMismatch ? "Mismatch" : "No Mismatch"}
    </span>
  );
};

const ChildMimatchStatus = ({ partnerName, godVal, partnerVal, condition, isPrice = false, itemNotFound = false }) => {
  return (
    <div>
      <p style={{ color: "#139a35", fontWeight: 600, marginBottom: 0 }}>
        Goddiva : <span>{isPrice ? `£ ${Number(godVal).toFixed(2)}` : `${godVal}`}</span>
      </p>
      <p style={{ color: condition ? "#dc0000" : "#139a35", fontWeight: 600, marginTop: 0 }}>
        {partnerName} : {itemNotFound === true ? "--" : <span>{isPrice ? `£ ${Number(partnerVal).toFixed(2)}` : `${partnerVal}`}</span>}
      </p>
    </div>
  );
};

function OrderReturnSec({
  orderCheckBoxData,
  setOrderCheckBoxData,
  partnerState,
  salesPage,
  setSalesPage,
  salesPageSize,
  setSalesPageSize,
  returnsPage,
  setReturnsPage,
  returnsPageSize,
  setreturnsPageSize,
  salesReturnLoading,
  partner,
}) {
  const [activeTab, setActiveTab] = useState("1");
  const [isChecked, setIsChecked] = useState(null);
  const [itemIdArray, setItemIdArray] = useState([]);
  const partnerId = Number(partner);
  const hideOrderLink = [20]; // partners IDs
  const isHide = hideOrderLink.includes(partnerId);

  const tableColumns = [
    {
      name: "Order #",
      selector: (row) => {
        return isHide ? (
          <div>{row.order_no}</div>
        ) : (
          <Link className="text-primary" style={{ cursor: "pointer" }} to={`${process.env.PUBLIC_URL}/order/${row.id}/view`}>
            {row.order_no}
          </Link>
        );
      },
      sortable: true,
      center: false,
    },
    {
      name: "MP Order ID",
      selector: (row) => (row.mp_order_id ? row.mp_order_id : "-"),
      sortable: true,
      center: false,
      width: "200px",
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: true,
      center: false,
    },
    {
      name: "Dispatch Date",
      selector: (row) => (row.dispatch_date ? row.dispatch_date : "-"),
      sortable: true,
      center: false,
    },
    // {
    //   name: "Return Date",
    //   selector: (row) => row.return_date,
    //   sortable: true,
    //   center: false,
    // },
    {
      name: "SKU",
      selector: (row) => <MismatchStatus value={row.is_sku_mismatch} />,
      sortable: true,
      center: false,
    },
    {
      name: "Price",
      selector: (row) => <MismatchStatus value={row.is_price_mismatch} />,
      sortable: true,
      center: false,
    },
    {
      name: "Qty",
      selector: (row) => <MismatchStatus value={row.is_quantity_mismatch} />,
      sortable: true,
      center: false,
    },
    {
      name: "Reason",
      selector: (row) => (row.reason ? row.reason : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "App/Dec By",
      selector: (row) => (row.app_dec_by ? row.app_dec_by : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "Approved/Declined Date",
      selector: (row) => (row.app_dec_date ? row.app_dec_date : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="py-1">
          {row.statuses.length > 0 ? (
            row.statuses.map((s, i) => (
              <p
                key={i}
                style={{
                  color: "#dc0000",
                  fontWeight: 500,
                  marginBottom: 1,
                  marginTop: 1,
                }}
              >
                {s}
              </p>
            ))
          ) : (
            <p
              style={{
                color: "#139a35",
                fontWeight: 500,
                marginBottom: 1,
                marginTop: 1,
              }}
            >
              No Mismatch
            </p>
          )}
        </div>
      ),
      sortable: true,
      left: true,
      width: "200px",
    },
    {
      name: "Action Status",
      selector: (row) => row.action_status,
      cell: (row) => (
        <div>
          <span className={`badge px-3 ${statusValue[row.status]}`}>{row.action_status}</span>
        </div>
      ),
      width: "200px",
      sortable: true,
      center: true,
    },
  ];

  const returntableColumns = [
    {
      name: "Order #",
      selector: (row) => {
        return isHide ? (
          <div>{row.order_no}</div>
        ) : (
          <Link className="text-primary" style={{ cursor: "pointer" }} to={`${process.env.PUBLIC_URL}/order/${row.id}/view`}>
            {row.order_no}
          </Link>
        );
      },
      sortable: true,
      center: false,
    },
    {
      name: "MP Order ID",
      selector: (row) => (row.mp_order_id ? row.mp_order_id : "-"),
      sortable: true,
      center: false,
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: true,
      center: false,
    },
    {
      name: "Dispatch Date",
      selector: (row) => (row.dispatch_date ? row.dispatch_date : "-"),
      sortable: true,
      center: false,
    },
    {
      name: "Return Date",
      selector: (row) => (row.isDirectRefund ? "Direct Refund" : row.return_at),
      sortable: true,
      center: false,
    },
    {
      name: "SKU",
      selector: (row) => <MismatchStatus value={row.is_sku_mismatch} />,
      sortable: true,
      center: false,
    },
    {
      name: "Price",
      selector: (row) => <MismatchStatus value={row.is_price_mismatch} />,
      sortable: true,
      center: false,
    },
    {
      name: "Qty",
      selector: (row) => <MismatchStatus value={row.is_quantity_mismatch} />,
      sortable: true,
      center: false,
    },
    {
      name: "Refund Status",
      selector: (row) => <MismatchStatus value={row.is_refund_mismatch} />,
      sortable: true,
      center: false,
    },
    {
      name: "Reason",
      selector: (row) => (row.reason ? row.reason : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "App/Dec By",
      selector: (row) => (row.app_dec_by ? row.app_dec_by : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "Approved/Declined Date",
      selector: (row) => (row.app_dec_date ? row.app_dec_date : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="py-1">
          {row.statuses.length > 0 ? (
            row.statuses.map((s, i) => (
              <p
                key={i}
                style={{
                  color: "#dc0000",
                  fontWeight: 500,
                  marginBottom: 1,
                  marginTop: 1,
                }}
              >
                {s}
              </p>
            ))
          ) : (
            <p
              style={{
                color: "#139a35",
                fontWeight: 500,
                marginBottom: 1,
                marginTop: 1,
              }}
            >
              No Mismatch
            </p>
          )}
        </div>
      ),
      sortable: true,
      left: true,
      width: "200px",
    },
    {
      name: "Action Status",
      selector: (row) => row.action_status,
      cell: (row) => (
        <div>
          <span className={`badge px-3 ${statusValue[row.status]}`}>{row.action_status}</span>
        </div>
      ),
      width: "200px",
      sortable: true,
      center: true,
    },
  ];

  const childConditionalRowStyles = [
    {
      when: (row) => row.is_item_not_found === true,
      style: {
        backgroundColor: "#ffe5e5",
        // color: "#d8000c",
      },
    },
    // {
    //   when: (row) => row.status === 2,
    //   style: {
    //     backgroundColor: "#e8f9e8",
    //     color: "#227a2b",
    //   },
    // },
  ];

  const ExpandedComponent = ({ data }) => {
    console.log("DATAAAA", data);
    const childData = data.items;
    const partnerName = data.partner_name;

    const childTableColumns = [
      {
        name: "SKU",
        selector: (row) => (
          <ChildMimatchStatus
            partnerName={partnerName}
            godVal={row.sku}
            partnerVal={row.excel_sku}
            condition={row.is_sku_mismatch}
            isPrice={false}
            itemNotFound={row.is_item_not_found}
          />
        ),
        sortable: false,
        center: false,
      },
      {
        name: "Price",
        selector: (row) => (
          <ChildMimatchStatus
            partnerName={partnerName}
            godVal={row.price}
            partnerVal={row.excel_price}
            condition={row.is_price_mismatch}
            isPrice={true}
            itemNotFound={row.is_item_not_found}
          />
        ),
        sortable: false,
        center: false,
      },
      {
        name: "Qty",
        selector: (row) => (
          <ChildMimatchStatus
            partnerName={partnerName}
            godVal={row.qty}
            partnerVal={row.excel_qty}
            condition={row.is_quantity_mismatch}
            isPrice={false}
            itemNotFound={row.is_item_not_found}
          />
        ),
        sortable: false,
        center: false,
      },
      {
        name: "Status",
        selector: (row) => (
          <div className="py-1">
            {row.statuses.length > 0 ? (
              row.statuses.map((s, i) => (
                <p
                  key={i}
                  style={{
                    color: "#dc0000",
                    fontWeight: 500,
                    marginBottom: 1,
                    marginTop: 1,
                  }}
                >
                  {s}
                </p>
              ))
            ) : (
              <p
                style={{
                  color: "#139a35",
                  fontWeight: 500,
                  marginBottom: 1,
                  marginTop: 1,
                }}
              >
                No Mismatch
              </p>
            )}
          </div>
        ),
        sortable: false,
        left: true,
        width: "200px",
      },
    ];

    return (
      <div className="px-5 pt-3 pb-5 border-bottom">
        <CommonDataTable
          headerColumns={childTableColumns}
          data={childData}
          noAction
          pagination={false}
          conditionalRowStyles={childConditionalRowStyles}
        />
      </div>
    );
  };

  const ReturnExpandedComponent = ({ data }) => {
    console.log("DATAAAA", data);
    const childData = data.items;
    const partnerName = data.partner_name;

    const childTableColumns = [
      {
        name: "SKU",
        selector: (row) => (
          <ChildMimatchStatus
            partnerName={partnerName}
            godVal={row.sku}
            partnerVal={row.excel_sku}
            condition={row.is_sku_mismatch}
            isPrice={false}
            itemNotFound={row.is_item_not_found}
          />
        ),
        sortable: false,
        center: false,
      },
      {
        name: "Price",
        selector: (row) => (
          <ChildMimatchStatus
            partnerName={partnerName}
            godVal={row.price}
            partnerVal={row.excel_price}
            condition={row.is_price_mismatch}
            isPrice={true}
            itemNotFound={row.is_item_not_found}
          />
        ),
        sortable: false,
        center: false,
      },
      {
        name: "Qty",
        selector: (row) => (
          <ChildMimatchStatus
            partnerName={partnerName}
            godVal={row.qty}
            partnerVal={row.excel_qty}
            condition={row.is_quantity_mismatch}
            isPrice={false}
            itemNotFound={row.is_item_not_found}
          />
        ),
        sortable: false,
        center: false,
      },
      {
        name: "Refund Status",
        selector: (row) => (
          <ChildMimatchStatus
            partnerName={partnerName}
            godVal={row.refund_status}
            partnerVal={row.excel_refund_status}
            condition={row.is_refund_mismatch}
            isPrice={false}
            itemNotFound={row.is_item_not_found}
          />
        ),
        sortable: false,
        center: false,
      },
      {
        name: "Status",
        selector: (row) => (
          <div className="py-1">
            {row.statuses.length > 0 ? (
              row.statuses.map((s, i) => (
                <p
                  key={i}
                  style={{
                    color: "#dc0000",
                    fontWeight: 500,
                    marginBottom: 1,
                    marginTop: 1,
                  }}
                >
                  {s}
                </p>
              ))
            ) : (
              <p
                style={{
                  color: "#139a35",
                  fontWeight: 500,
                  marginBottom: 1,
                  marginTop: 1,
                }}
              >
                No Mismatch
              </p>
            )}
          </div>
        ),
        sortable: false,
        left: true,
        width: "200px",
      },
    ];

    return (
      <div className="px-5 pt-3 pb-5 border-bottom">
        <CommonDataTable
          headerColumns={childTableColumns}
          data={childData}
          noAction
          pagination={false}
          conditionalRowStyles={childConditionalRowStyles}
        />
      </div>
    );
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.is_order_not_found === true,
      style: {
        backgroundColor: "#ffe5e5",
        // color: "#d8000c",
      },
    },
    // {
    //   when: (row) => row.status === 2,
    //   style: {
    //     backgroundColor: "#e8f9e8",
    //     color: "#227a2b",
    //   },
    // },
  ];

  // const selectableRowDisabled = (row) => {
  //   if (row.status === 2 || row.status === 3) return true;

  //   return false;
  // };

  const handleChange = (state) => {
    const selectedIDs = state.selectedRows.map((row) => row.partner_invoice_id);
    const selectedOrderIDs = state.selectedRows.map((row) => row.id);
    const isInclude = state.selectedRows.some((row) => row.status === 2 || row.status === 3);

    setOrderCheckBoxData({ idArray: selectedIDs, orderIds: selectedOrderIDs, activeTab: activeTab, isIncludeAppDecItems: isInclude });
    setItemIdArray(selectedIDs);
    setIsChecked(selectedIDs.length > 0);
  };

  const pageChange = (e) => {
    setSalesPage(e);
  };

  const onPageSizeChange = (e) => {
    setSalesPage(1);
    setSalesPageSize(e);
  };

  const returnPageChange = (e) => {
    setReturnsPage(e);
  };

  const onReturnPageSizeChange = (e) => {
    setReturnsPage(1);
    setreturnsPageSize(e);
  };

  const handleTabChange = (tabId) => {
    if (activeTab !== tabId) {
      setActiveTab(tabId);

      setOrderCheckBoxData({ idArray: [], orderIds: [], activeTab: tabId, isIncludeAppDecItems: false });
      setItemIdArray([]);
      setIsChecked(null);
    }
  };


  return (
    <Fragment>
      <Nav tabs>
        <NavItem>
          <NavLink href="#" className={activeTab === "1" ? "active" : ""} onClick={() => handleTabChange("1")}>
            <strong>Orders</strong>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink href="#" className={activeTab === "2" ? "active" : ""} onClick={() => handleTabChange("2")}>
            <strong>Returns</strong>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Card className="mt-4 ribbon-wrapper">
            <CardBody>
              <div className="ribbon ribbon-clip ribbon-dark h6">Orders</div>

              {salesReturnLoading ? (
                <div style={{ minHeight: 400 }}>
                  <PreLoader />
                </div>
              ) : (
                <div className="table-responsive product-table">
                  <BackInStockTable
                    // toggleRowSelected={toggleRowSelected}
                    key={`orders-${activeTab}`}
                    paginationTotalRows={partnerState.salesTableRow}
                    idArray={orderCheckBoxData}
                    // selectableRowDisabled={selectableRowDisabled}
                    tableColumns={tableColumns}
                    backStockData={partnerState.salesData || []}
                    backInRequestState={partnerState}
                    pageChange={pageChange}
                    onPageSizeChange={onPageSizeChange}
                    handleChange={handleChange}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    paginationDefaultPage={salesPage}
                    paginationPerPage={salesPageSize}
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="2">
          <Card className="mt-4 ribbon-wrapper">
            <CardBody>
              <div className="ribbon ribbon-clip ribbon-dark h6">Returns</div>
              {salesReturnLoading ? (
                <div style={{ minHeight: 400 }}>
                  <PreLoader />
                </div>
              ) : (
                <div className="table-responsive product-table">
                  <BackInStockTable
                    // toggleRowSelected={toggleRowSelected}
                    key={`returns-${activeTab}`}
                    paginationTotalRows={partnerState.returnTableRow}
                    // selectableRowDisabled={selectableRowDisabled}
                    idArray={orderCheckBoxData}
                    tableColumns={returntableColumns}
                    backStockData={partnerState.returnData || []}
                    backInRequestState={partnerState}
                    pageChange={returnPageChange}
                    onPageSizeChange={onReturnPageSizeChange}
                    handleChange={handleChange}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    paginationDefaultPage={returnsPage}
                    paginationPerPage={returnsPageSize}
                    expandableRows
                    expandableRowsComponent={ReturnExpandedComponent}
                    conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </TabPane>
      </TabContent>
    </Fragment>
  );
}

export default OrderReturnSec;
